<style lang="scss" scoped>
.categorys-name {
    font-size: 14px;
}

.categorys-code {
    font-size: 12px;
    margin-left: 20px;
}
.categorys-connector {
    font-size: 12px;
    margin-left: 20px;
}
.link-span {
    .category-link {
        margin-left: 5px;
    }

    margin-left: 15px;
}
.categorys-main {
    margin: 5px;
    overflow-x: hidden;
    overflow-y: auto;
}
</style>

<template>
    <div class="categorys-main" :style="'height:' + (this.$tools.mainHeight() - 10) + 'px;'">
        <el-tree
            :data="categorys"
            node-key="id"
            default-expand-all
            :expand-on-click-node="false"
            ref="categorysTree"
            draggable
            @node-drop="nodeDrop"
        >
            <span class="custom-tree-node" slot-scope="{ node, data }">
                <span class="categorys-name">{{ data.name }}</span>
                <span class="categorys-code">{{ data.code }}</span>
                <span class="categorys-connector">{{ data.connector }}</span>
                <span class="link-span">
                    <el-link
                        class="category-link"
                        type="success"
                        size="mini"
                        @click="append(data)"
                    >添加</el-link>
                    <el-link class="category-link" type="primary" size="mini" @click="edit(data)">编辑</el-link>
                    <el-link
                        class="category-link"
                        type="danger"
                        size="mini"
                        @click="remove(node, data)"
                    >删除</el-link>
                </span>
            </span>
        </el-tree>

        <el-dialog
            :visible.sync="showDialog"
            :title="!category || !category.id ? '新增': '编辑'"
            @closed="refeshRule"
            width="400px"
        >
            <el-form label-width="80px" :model="category" ref="categoryForm" :rules="rules">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="category.name"></el-input>
                </el-form-item>

                <el-form-item label="编码" prop="code">
                    <el-input v-model="category.code"></el-input>
                </el-form-item>

                <el-form-item label="连接符" prop="connector">
                    <el-input v-model="category.connector"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    size="small"
                    v-on:click="doAppend"
                    class="op-button"
                    v-if="!category.id"
                >保存</el-button>
                <el-button
                    type="primary"
                    size="small"
                    v-on:click="doEdit"
                    class="op-button"
                    v-if="category.id"
                >保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            categorys: [],
            showDialog: false,
            category: {},
            rules: {
                name: [
                    { required: true, message: "请输入名称", trigger: "blur" },
                    {
                        min: 2,
                        max: 30,
                        message: "长度在 2 到 30 个字符",
                        trigger: "blur",
                    },
                ],

                code: [
                    {  message: "请输入编码", trigger: "blur" },
                    {
                        min: 1,
                        max: 10,
                        message: "长度在 1 到 10 个字符",
                        trigger: "blur",
                    },
                ],
                connector: [
                    { message: "请输连接符", trigger: "blur" },
                    {
                        min: 1,
                        max: 10,
                        message: "长度在 1 到 10 个字符",
                        trigger: "blur",
                    },
                ],
            },
            tempData: null,
        };
    },
    methods: {
        loadData() {
            let _this = this;

            _this.$http.post(
                ["alibaba/product/category/tree"],
                [
                    function (data) {
                        _this.categorys = data;
                    },
                ],
                ".categorys-main"
            );
        },
        append(data) {
            this.category = {};
            this.showDialog = true;
            this.tempData = data;
        },
        doAppend() {
            let _this = this;

            _this.$refs["categoryForm"].validate().then(function (data) {
                _this.category.parentId = _this.tempData.id;

                _this.$http.post(
                    ["alibaba/product/category/save", _this.category],
                    [
                        function (data, msg) {
                            _this.category.id = data;

                            _this.appendNode(_this, _this.tempData, {
                                id: data,
                                name: _this.category.name,
                                parentId: _this.category.parentId,
                            });

                            _this.showDialog = false;

                             msg("添加成功");
                        },
                    ],
                    ".categorys-main"
                );
            });
        },
        appendNode(_this, data, addData) {
            if (!data.children) {
                _this.$set(data, "children", []);
            }
            data.children.push(addData);
        },
        edit(data) {
            this.category = {
                id: data.id,
                name: data.name,
                connector: data.connector,
                parentId: data.parentId,
                code: data.code,
                sn: data.sn,
            };

            this.showDialog = true;
            this.tempData = data;
        },
        nodeDrop(draggingNode, dropNode, dropType, ev) {
            let _this = this;
            let insertId =
                dropType == "inner" ? dropNode.data.id : dropNode.data.parentId;

            _this.$http.post(
                [
                    "alibaba/product/category/save",
                    {
                        id: draggingNode.data.id,
                        dropType: dropType,
                        dropId: dropNode.data.id,
                    },
                ],
                [
                    function (data, msg) {
                        msg("操作成功");
                    },
                ],
                ".categorys-main"
            );
        },
        doEdit(_t) {
            let _this = this;

            _this.$refs["categoryForm"].validate().then(function () {
                _this.$http.post(
                    ["alibaba/product/category/save", _this.category],
                    [
                        function (data) {
                            _this.editNode(
                                _this,
                                _this.tempData.id,
                                _this.category.name,
                                _this.category.parentId,
                                _this.category.connector,
                                _this.category.sn,
                                _this.category.children
                            );
                            _this.showDialog = false;
                        },
                    ],
                    ".categorys-main"
                );
            });
        },
        editNode(_this, id, name, parentId, connector, children) {
            _this.$refs["categorysTree"].getNode(id).data = {
                id: id,
                name: name,
                parentId: parentId,
                connector: connector,
                children: children,
            };
        },
        remove(node, data) {
            let _this = this;

            _this.$tConfirm.show(
                "确认删除【" + data.name + "】？",
                function () {
                    _this.$http.post(
                        ["alibaba/product/category/delete", { id: data.id }],
                        [
                            function (data) {
                                if (data) {
                                    const parent = node.parent;
                                    const children =
                                        parent.data.children || parent.data;
                                    const index = children.findIndex(
                                        (d) => d.id === data.id
                                    );
                                    children.splice(index, 1);
                                }
                            },
                        ],
                        ".categorys-main"
                    );
                }
            );
        },
        refeshRule() {
            this.$refs["categoryForm"].resetFields();
        },
    },
    mounted() {
        this.loadData();
    },
};
</script>
